import SubmissionAssetUpload from './SubmissionAssetUpload';

export default SubmissionAssetUpload;
